import React from 'react';
import Slider from 'react-slick';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faStar,
    faStarHalfAlt,
    faQuoteRight,
} from '@fortawesome/free-solid-svg-icons';
import { Images } from '../../../../assets/assets';
import './TestimonialSlider.css';
import { useTestimonialStore } from '../../../../store/useTestimonialStore';
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../Loader';

const testimonials = [
    {
        rating: 4.5,
        text: "The entire team at Precision Handyman filled me with confidence and the project ran smoothly from start to finish. I would highly recommend Precision Handyman.",
        name: 'Michael Praz',
        designation: 'Designation',
        image: Images.User1,
    },
    {
        rating: 4.5,
        text: "I recently had the pleasure of using Fixit for a variety of home repairs, and I am beyond impressed with their exceptional service.",
        name: 'Diandra Alexa',
        designation: 'Designation',
        image: Images.User2,
    },
    {
        rating: 4.5,
        text: "The entire team at Precision Handyman filled me with confidence and the project ran smoothly from start to finish. I would highly recommend Precision Handyman.",
        name: 'Michael Praz',
        designation: 'Designation',
        image: Images.User1,
    },
];

const getStars = (rating) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const stars = [];

    for (let i = 0; i < fullStars; i++) {
        stars.push(<FontAwesomeIcon key={`star-${i}`} icon={faStar} className="star-icon" />);
    }

    if (halfStar) {
        stars.push(<FontAwesomeIcon key="half-star" icon={faStarHalfAlt} className="star-icon" />);
    }

    return stars;
};

export default function TestimonialSlider() {
    const { testimonial, testimonialPage, getTestimonial } = useTestimonialStore();
    const [loading, setLoading] = useState(false)
    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    const fetchTestimonialsFunction = async () => {
        if (testimonial.length > 0 && testimonialPage) return;
        setLoading(true)
        await getTestimonial()
        setLoading(false)
    }

    useEffect(() => {
        fetchTestimonialsFunction();
    }, [])
    return (
        <section className="testimonial-section">
            <Container className="theme-container">
                <div className="text-center mb-5">
                    <p className="section-subtitle mb-1">{testimonialPage?.subTitle}</p>
                    <h3 className="section-title">{testimonialPage?.title}</h3>
                    <p className="section-sub">
                        {testimonialPage?.description}
                    </p>
                </div>
                <Loader loading={loading}>
                    <Slider {...settings}>
                        {(testimonial || []).map((item, idx) => (
                            <div className="testimonial-card" key={idx}>
                                <div className="rating">{getStars(item?.rating)}</div>
                                <p className="testimonial-text">“{item?.comment}”</p>
                                <div className="testimonial-footer">
                                    <div className="author">
                                        {/* <img src={item?.avatar} alt={item?.name} className="author-img" /> */}
                                        <div>
                                            <h6 className="author-name">{item?.name}</h6>
                                            <span className="author-role text-light-gray fs-6">{item?.designation}</span>
                                        </div>
                                    </div>
                                    <FontAwesomeIcon icon={faQuoteRight} className="quote-symbol" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </Loader>
            </Container>
        </section>
    );
}
